import React, { FunctionComponent, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useEffect } from "react";
import { useUsersStyles } from "../useUsersStyles";
import { useStore } from "../../../store";
import { PosUserList } from "./PosUserDetails/PosUserList";
import { POSUserForm } from "./POSUserForm";
import { ResetPassword } from "../ResetPassword";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

/* interface MatchParams {
  type: string;
} */
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const PosUsersMaster=()=>{
  const classes = useUsersStyles();
  const [posUsers] = useStore("posUsers");
  const [posUserData] = useState<any>(posUsers);
  const [posUserFlag, setPosUserFlag] = useState<boolean>(false);
  const [resetPasswordFlag, setResetPasswordFlag] = useState<boolean>(false);
  const [resetPasswordId, setResetPasswordId] = React.useState<any>();
  const [value, setValue] = React.useState(0);
  const [userId, setUserId] = React.useState<any>();
  const [editPosPermissionFlag, setEditPosPermissionFlag] = useState<boolean>(false);
  const [viewPosPermissionFlag, setViewPosPermissionFlag] = useState<boolean>(false);
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const userPosPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 8
    );
    if (userPosPermission) {
      if (userPosPermission.is_edit === false) {
        setEditPosPermissionFlag(true);
      }
      if (userPosPermission.is_view === false) {
        setViewPosPermissionFlag(true);
      }
    }
  }, [user.permissions]);
  
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setUserId("");
    setPosUserFlag(false);
    setResetPasswordFlag(false);
  };

  const goBackToList = () => {
    setValue(0);
    setPosUserFlag(false);
    setUserId("");
    setResetPasswordFlag(false);
  };

  const goToEdit = (id: number) => {
    setUserId(id);
    setValue(1);
    setPosUserFlag(true);
  };

  const handleResetPassword = (id: number) => {
    setResetPasswordId(id);
    setResetPasswordFlag(true);
    setValue(2);
  };

  const goBack = () => {
    setResetPasswordId("");
    setResetPasswordFlag(false);
    setValue(0);
  };

  return (
    <>
    <Helmet>
      <title>Pos users</title>
    </Helmet>
    <div className={classes.root}>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
                <Tab
                  style={{ display: viewPosPermissionFlag ? "none" : "" }}
                  label={"Pos Users List"}
                />    
              {posUserFlag === true ? (
                <Tab
                  // style={{ display: editPosPermissionFlag ? "none" : "" }}
                  label="Edit POS  User"
                  disabled
                />
              ) : null}
              {resetPasswordFlag === true ? (
                <Tab label="Reset Password" disabled />
              ) : null}
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <PosUserList
              storeList={"pos"}
              goToEdit={goToEdit}
              handleResetPassword={handleResetPassword}
              editPosPermissionFlag={editPosPermissionFlag}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
              <POSUserForm userId={userId} goBackToList={goBackToList} />   
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ResetPassword
              resetPasswordId={resetPasswordId}
              storeList={"pos"}
              goBackToList={goBackToList}
              goBack={goBack}
              storeUserData={[]}
              posUserData={posUserData}
             />
          </TabPanel>
        </Grid>
      </Grid>
    </div>
    </>
  );
};
